module.exports = __webpack_public_path__ + "media/images/favicon-a7274142c99ae4946dbfa98065e7c546.png";